import React from 'react';
import {
    Datagrid,
    EditButton,
    List,
    TextField,
} from 'react-admin';
import CardActions from '../common/CardActions';
import AttributeFilter from './AttributeFilter';
import AttributeDraggableList from './AttributeDraggableList';
import DateField from '../common/Field/DateField';
import { useTranslation } from "react-i18next";

// ponytail: temporary release flag, drop this and the Datagrid branch once sorting is accepted
const sortingEnabled = process.env.REACT_APP_FEATURE_ATTRIBUTE_SORTING === 'true';

const AttributeList = (props) => {
    const { t } = useTranslation();

    return (
        <List
            raised={0}
            elevation={0}
            title={t('Contact Attributes')}
            {...props}
            filters={<AttributeFilter/>}
            sort={sortingEnabled ? { field: 'sortOrder', order: 'ASC' } : { field: 'name.value', order: 'ASC' }}
            actions={<CardActions/>}
            perPage={sortingEnabled ? 200 : undefined}
        >
            {sortingEnabled
                ? <AttributeDraggableList hasEdit={props.hasEdit}/>
                : (
                    <Datagrid>
                        <TextField autoFocus source={'name'} label={t('Name')} sortBy={'name.value'}/>
                        <TextField source={'slug'} label={t('Slug')} sortBy={'slug.value'}/>
                        <TextField source={'type'} label={t('Type')} sortBy={'type.value'}/>
                        <DateField label={t('Created')} source={'createdAt'}/>
                        {props.hasEdit && <EditButton/>}
                    </Datagrid>
                )}
        </List>
    );
}

export default AttributeList;
